import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";
import AuthModal from "../../components/AuthModal";

export default function RegisterPage() {
  const { user } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      console.log('[RegisterPage] User already logged in:', { uid: user.uid, email: user.email, role: user.role });
      
      if (user.role === 'instructor') {
        navigate('/instructor/dashboard');
      } else {
        navigate('/progress');
      }
    }
  }, [user, navigate]);

  return (
    <AuthModal 
      isOpen={true} 
      onClose={() => navigate('/')} 
    />
  );
}
